export default __webpack_public_path__ + "static/media/varunada_lazurite_gemstone.469130b9.png";